import { __awaiter } from "tslib";
import { axiosClient, CookieUtil } from '@as-react/common-utils';
import { Cookie, } from '@as-react/common-types';
class StoreAPI {
    setClickAndCollectStoreId(servicesEndpoint, defaultRequestParams, storeId) {
        const updateClickAndCollectStoreUrl = `${servicesEndpoint}api/buy/delivery/clickandcollect`;
        CookieUtil.set(Cookie.CLICK_AND_COLLECT_STORE, storeId.toString(), { secure: true });
        const axiosConfig = {
            method: 'POST',
            url: updateClickAndCollectStoreUrl,
            params: Object.assign(Object.assign({}, defaultRequestParams), { storeId: storeId }),
            withCredentials: true,
        };
        return axiosClient.request(axiosConfig);
    }
    getShopLandingStoreInfo(servicesApi, defaultRequestParams, shopNumber) {
        return __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'GET',
                url: `${servicesApi}api/services/public/store/shoplanding/${defaultRequestParams.mainWebshop}/${shopNumber}/${defaultRequestParams.language}`,
            };
            try {
                const request = yield axiosClient.request(axiosConfig);
                return request.data;
            }
            catch (_a) {
                return null;
            }
        });
    }
    getShoplandingInfo(servicesApi, market, shopNumber) {
        return __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'GET',
                url: `${servicesApi}api/shoplanding/storenumberads/${market}/${shopNumber}`,
            };
            try {
                const request = yield axiosClient.request(axiosConfig);
                return request.data;
            }
            catch (_a) {
                return null;
            }
        });
    }
    getStoreInfoByStoreId(servicesApi, defaultRequestParams, storeId) {
        return __awaiter(this, void 0, void 0, function* () {
            const axiosConfig = {
                method: 'GET',
                url: `${servicesApi}api/store/info/${defaultRequestParams.mainWebshop}/${storeId}?language=${defaultRequestParams.language}`,
            };
            const request = yield axiosClient.request(axiosConfig);
            return request.data;
        });
    }
    getStoreInformation(servicesApi_1, _a, businessUnitId_1, storeId_1) {
        return __awaiter(this, arguments, void 0, function* (servicesApi, { market, language, shopId }, businessUnitId, storeId, weeks = 1) {
            const axiosConfig = {
                method: 'GET',
                url: `${servicesApi}api/store/schedule`,
                params: {
                    market,
                    language,
                    businessUnitId,
                    fictiveWebShopId: shopId,
                    storeId,
                    weeks,
                },
            };
            const request = yield axiosClient.request(axiosConfig);
            return request.data;
        });
    }
}
export default new StoreAPI();
